/**
 * Groups an array of indicator configs by theme.
 *
 * Returns [{theme: string|null, indicators: []}] — theme sections in definition
 * order, with any ungrouped indicators appended at the end as theme: null.
 *
 * An indicator appears in at most one theme (first-match wins). Themes with no
 * matching enabled indicators are silently skipped.
 */
export function groupIndicators(indicators, themes = []) {
  if (!themes.length) return [{ theme: null, indicators: [...indicators] }];

  const assigned = new Set();
  const sections = [];

  for (const t of themes) {
    if (!t.label?.trim()) continue;
    const group = t.indicatorIds
      .map(id => indicators.find(i => i.id === id))
      .filter(Boolean)
      .filter(i => !assigned.has(i.id));
    group.forEach(i => assigned.add(i.id));
    if (group.length > 0) sections.push({ theme: t.label.trim(), indicators: group });
  }

  const ungrouped = indicators.filter(i => !assigned.has(i.id));
  if (ungrouped.length > 0) sections.push({ theme: null, indicators: ungrouped });

  return sections;
}
